//
import WhDispatchRequestBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'

//
export default class WhDispatchRequestBatchToList extends WhDispatchRequestBatchModel {

    /**
     * the dispatch batch includes
     */
    static includes = [
        'g_state',
        'supervisor_g_user.hr_employee',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.sl_customer',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.sl_customer_branch_offices',
        'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.g_seller_user.hr_employee',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.payment_types',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.sl_sale_invoice',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.g_state',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.pch_payment_condition',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.wh_detail_dispatch_requests',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.wh_detail_dispatch_requests.wh_product',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.wh_detail_dispatch_requests.wh_warehouse',
    ]
}
